module.exports = __webpack_public_path__ + "img/i.5e42b354.svg";